<igx-grid [data]="accounts" [allowFiltering]="true">
    <igx-paginator />
    <igx-column field="accountName" [sortable]="true" header="{{ 'PaymentAccount.AccountName' | translate }}" [resizable]="true" />
    <igx-column field="ibanOrNumber" [sortable]="true" header="{{ 'PaymentAccount.IbanOrNumber' | translate }}" [resizable]="true" />
    <igx-column field="bankName" [sortable]="true" header="{{ 'PaymentAccount.BankName' | translate }}" [resizable]="true" />
    <igx-column field="accountHolder" [sortable]="true" header="{{ 'PaymentAccount.Beneficiary' | translate }}" [resizable]="true" />
</igx-grid>
